import { render, staticRenderFns } from "./CommNav.vue?vue&type=template&id=ad19cb5a&scoped=true"
import script from "./CommNav.vue?vue&type=script&lang=js"
export * from "./CommNav.vue?vue&type=script&lang=js"
import style0 from "./CommNav.vue?vue&type=style&index=0&id=ad19cb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad19cb5a",
  null
  
)

export default component.exports